<template>
    <v-app id="inspire">
        <section class="registration-form">
            <div class="container">
                <validation-observer ref="form">
                    <div class="row mb-5">
                        <div class="col-12">
                            <h2>Contactformulier</h2>
                            <p v-if="success" v-html="succesMessage"></p>
                            <a
                                v-if="success"
                                :href="successLink.url"
                                class="btn btn--purple"
                                ><span>{{ successLink.name }}</span></a
                            >
                        </div>
                    </div>
                    <form v-show="!success" @submit.prevent="signup">
                        <div class="row mb-4">
                            <div class="col-12">
                                <p v-if="activity != null && provider != null">
                                    Je neemt contact op over de activiteit:
                                    {{ activity.title }}. <br />
                                    Deze activiteit wordt aangeboden door:
                                    {{ provider.name }}
                                </p>
                            </div>
                            <dropdown-input
                                v-show="
                                    user == null ||
                                        Object.keys(user).length === 0
                                "
                                ref="signupType"
                                v-model="form.signupType"
                                class="col-6"
                                :options="signupTypes"
                                name="Ik ben:"
                                rules="required"
                            />
                        </div>
                        <div v-if="showLoginMsg">
                            <div v-html="loginText"></div>
                            <div>
                                <a :href="loginUrl" class="btn ml-2">
                                    <span>
                                        Login
                                        <i
                                            class="fa fa-arrow-right ml-2"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="form.signupType !== 1" class="row mb-4">
                                <div class="col-12">
                                    <h3>{{ formName }}</h3>
                                </div>
                                <text-input
                                    ref="schoolName"
                                    v-model="form.schoolName"
                                    class="col-12 col-sm-6 mb-2"
                                    :name="formSchoolField"
                                    :readonly="disallowModifySchoolName"
                                    placeholder=""
                                />
                                <text-input
                                    v-if="form.signupType === 2"
                                    ref="brinNumber"
                                    v-model="form.brinNumber"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Brin nummer"
                                    :readonly="disallowModifySchoolName"
                                    rules="required"
                                    placeholder=""
                                />
                                <text-input
                                    v-if="form.signupType === 3"
                                    ref="LRKNumber"
                                    v-model="form.lrkNumber"
                                    class="col-12 col-sm-6 mb-2"
                                    name="LRK nummer"
                                    rules="required"
                                    placeholder=""
                                />
                                <text-input
                                    ref="postalCode"
                                    v-model="form.postalCode"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Postcode"
                                    :rules="{
                                        regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
                                    }"
                                    placeholder=""
                                />
                                <text-input
                                    ref="address"
                                    v-model="form.address"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Straat en huisnummer"
                                    rules="required"
                                    placeholder=""
                                />
                                <text-input
                                    ref="city"
                                    v-model="form.city"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Plaats"
                                    rules="required"
                                    placeholder=""
                                />
                                <text-input
                                    ref="phone"
                                    v-model="form.phone"
                                    class="col-12 col-sm-6 mb-2"
                                    name="Telefoon"
                                    rules="required|digits:10"
                                />
                            </div>
                            <div v-if="form.signupType !== 1" class="row mb-4">
                                <div class="col-12">
                                    <h3>
                                        Klas informatie
                                    </h3>
                                </div>
                                <div
                                    v-if="
                                        user !== null &&
                                            Object.keys(user).length > 0 &&
                                            form.signupType === 2 &&
                                            user.groups &&
                                            user.groups.length
                                    "
                                    class="col-12 col-sm-6 mb-2"
                                >
                                    <dropdown-input
                                        ref="group"
                                        v-model="form.group"
                                        class="col-6"
                                        :options="user.groups"
                                        name="Groep"
                                        rules="required"
                                    />
                                </div>
                                <div v-else class="col-12 col-sm-6 mb-2">
                                    <text-input
                                        ref="group"
                                        v-model="form.group"
                                        name="Groep"
                                        rules="required"
                                        placeholder=""
                                    />
                                </div>
                                <div class="col-12 col-sm-6 mb-2">
                                    <text-input
                                        ref="studentAmount"
                                        v-model="form.studentAmount"
                                        name="Aantal leerlingen"
                                        placeholder="1"
                                    />
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-12">
                                    <h3 v-if="form.signupType === 1">
                                        Ouder / Verzorger
                                    </h3>
                                    <h3 v-else>Leerkracht / begeleider</h3>
                                </div>
                                <text-input
                                    ref="contactName"
                                    v-model="form.contactName"
                                    class="col-12 col-sm-4 mb-2"
                                    name="Naam"
                                    rules="required"
                                    placeholder=""
                                />
                                <text-input
                                    ref="contactEmail"
                                    v-model="form.contactEmail"
                                    class="col-12 col-sm-4 mb-2"
                                    name="E-mailadres"
                                    rules="required|email"
                                    placeholder=""
                                />
                                <text-input
                                    ref="contactPhone"
                                    v-model="form.contactPhone"
                                    class="col-12 col-sm-4 mb-2"
                                    name="Telefoonnummer"
                                    rules="digits:10"
                                />
                            </div>
                            <div class="row mb-4">
                                <textarea-input
                                    ref="comments"
                                    v-model="form.comments"
                                    class="col-12 mb-2"
                                    name="Vragen/opmerkingen"
                                />
                                <checkbox-input
                                    v-if="privacyLink"
                                    v-model="form.privacyAccepted"
                                    class="col-12 mb-2"
                                    name="U dient akkoord te gaan met de algemene voorwaarden"
                                    rules="required"
                                >
                                    <slot>
                                        Ik ga akkoord met de
                                        <a
                                            :href="privacyLink.url"
                                            target="_blank"
                                            class="ml-1 color--blue-7"
                                        >
                                            algemene voorwaarden
                                        </a>
                                    </slot>
                                </checkbox-input>
                            </div>
                            <div class="row mb-4">
                                <button
                                    v-if="!loading"
                                    type="submit"
                                    class="btn mr-4 h-100"
                                    :class="{
                                        'btn btn--gray-4 disabled': btnDisabled
                                    }"
                                    :disabled="btnDisabled"
                                >
                                    <span>Verstuur!</span>
                                </button>
                                <spinner v-if="loading" />
                            </div>

                            <div
                                v-if="accountExists == true"
                                class="fixed-top d-flex justify-content-center message--login"
                            >
                                <div class="w-75 mt-4 mb-2">
                                    <h3>
                                        Het opgegeven account bestaat al. Log nu
                                        in om je aan te melden
                                        <a :href="loginUrl" class="btn ml-2">
                                            <span>
                                                Login
                                                <i
                                                    class="fa fa-arrow-right ml-2"
                                                    aria-hidden="true"
                                                ></i>
                                            </span>
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </form>
                </validation-observer>
            </div>
        </section>
    </v-app>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import textInput from '@/components/form/text-input';
import checkboxInput from '@/components/form/checkbox-input';
import textareaInput from '@/components/form/textarea-input';
import dropdownInput from '@/components/form/dropdown-input';
import spinner from '@/components/spinner';
import Axios from 'axios';

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput,
        checkboxInput,
        textareaInput,
        dropdownInput,
        spinner
    },
    props: {
        privacyLink: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            form: {
                signupType: 1,
                brinNumber: '',
                lrkNumber: '',
                schoolName: '',
                postalCode: '',
                address: '',
                city: '',
                phone: '',
                group: '',
                studentAmount: '',
                contactName: '',
                contactEmail: '',
                contactPhone: '',
                comments: '',
                newsletterVerwonder: false,
                newsletterProvider: false,
                privacyAccepted: false,
                activityId: '',
                providerId: ''
            },
            errorMessage:
                'Controleer jouw invoer, mogelijk zijn er verplichte velden niet ingevuld of zijn er velden niet correct ingevuld.',
            succesMessage:
                'Bedankt voor je interesse in deze activiteit. De aanbieder neemt zo snel mogelijk contact met je op.',
            successLink: {},
            dateErrorMessage: '',
            timeErrorMessage: '',
            validationError: false,
            success: false,
            url: '/api/inforequest/addinforequest',
            signupTypes: [],
            activity: {},
            provider: {},
            submitted: false,
            error: false,
            btnDisabled: false,
            loading: false,
            bookingLink: '',
            noAccountMessage: '',
            menu: false,
            menu2: false,
            accountExists: false,
            loginUrl: '',
            loginText: ''
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        disallowModifySchoolName() {
            return (
                this.user &&
                (this.user.contentTypeAlias === 'teacher' ||
                    this.user.contentTypeAlias === 'school')
            );
        },
        showLoginMsg() {
            return (
                !this.user &&
                (this.form.signupType === 2 || this.form.signupType === 4)
            );
        },
        formName() {
            switch (this.form.signupType) {
                case 3:
                    return 'BSO';
                default:
                    return 'School / BSO';
            }
        },
        formSchoolField() {
            switch (this.form.signupType) {
                case 3:
                    return 'Naam BSO';
                default:
                    return 'Schoolnaam';
            }
        }
    },
    watch: {
        user: function(user) {
            if (user != null) {
                switch (user.contentTypeAlias) {
                    case 'parent':
                        this.$refs.signupType.currentValue = 1;
                        this.form.signupType = 1;
                        break;
                    case 'school':
                        this.$refs.signupType.currentValue = 2;
                        this.form.signupType = 2;
                        this.form.brinNumber = user.brin;
                        break;
                    case 'bso':
                        this.$refs.signupType.currentValue = 3;
                        this.form.signupType = 3;
                        this.form.lrkNumber = user.lrk;
                        break;
                    case 'teacher':
                        this.$refs.signupType.currentValue = 4;
                        this.form.signupType = 4;
                        this.form.brinNumber = user.school.brin;
                        this.form.schoolName = user.school.name;
                        this.form.postalCode = user.school.zipcode;
                        this.form.address = (
                            user.school.street +
                            ' ' +
                            user.school.housenumber
                        ).trim();
                        if (
                            user.school.housenumberAddition != null &&
                            user.school.housenumberAddition != '' &&
                            user.school.housenumberAddition != 'null'
                        ) {
                            this.form.address +=
                                ' ' + user.school.housenumberAddition.trim();
                        }
                        this.form.city = user.school.city;
                        this.form.phone = user.school.phone;
                        this.form.childGroup = user.group;
                        this.form.contactName = user.fullName;
                        this.form.contactEmail = user.userName;
                        this.form.contactPhone = user.school.phone;
                        this.form.group =
                            user.groups != null &&
                            user.groups.length > 0 &&
                            user.groups[0] != null
                                ? user.groups[0].name
                                : '';
                        break;
                }

                if (user.contentTypeAlias !== 'teacher') {
                    this.form.schoolName = user.name;
                    this.form.postalCode = user.zipcode;
                    this.form.address = (
                        user.street +
                        ' ' +
                        user.housenumber
                    ).trim();
                    if (
                        user.housenumberAddition != null &&
                        user.housenumberAddition != '' &&
                        user.housenumberAddition != 'null'
                    ) {
                        this.form.address +=
                            ' ' + user.housenumberAddition.trim();
                    }
                    this.form.city = user.city;
                    this.form.phone = user.phone;
                    this.form.contactName = user.contactPersonFullName;
                    this.form.contactEmail = user.userName;
                    this.form.contactPhone = user.contactPersonPhone;
                }
            }
        },
        'form.contactEmail': function() {
            this.checkEmail();
        }
    },
    created() {
        this.getSignupTypes();
        this.getBookingLink();
        this.getNoAccountMessage();
        this.getLoginUrl();
        this.getSuccessLink();
        this.getLoginText();

        if (this.$route.query.activityId) {
            this.form.activityId = this.$route.query.activityId;
            this.activity = this.getActivity();
        }

        if (this.$route.query.providerId) {
            this.form.providerId = this.$route.query.providerId;
            this.provider = this.getProvider();
        }
    },
    methods: {
        getLoginUrl() {
            Axios.get('/api/inforequest/loginformurl')
                .then(response => {
                    this.loginUrl =
                        response.data +
                        '?activityId=' +
                        this.form.activityId +
                        '&providerId=' +
                        this.form.providerId;
                })
                .catch(() => false);
        },
        getActivity() {
            this.loading = true;
            Axios.get('/w3subookings/activity/get', {
                params: {
                    activityId: this.form.activityId
                }
            })
                .then(response => {
                    this.activity = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getProvider() {
            this.loading = true;
            Axios.get('/w3subookings/provider/get', {
                params: {
                    providerId: this.form.providerId
                }
            })
                .then(response => {
                    this.provider = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        checkEmail() {
            if (this.form.contactEmail != '') {
                Axios.get('/w3subookings/member/loggedin', {})
                    .then(response => {
                        if (response.data == false) {
                            Axios.get('/w3subookings/member/exists', {
                                params: {
                                    email: this.form.contactEmail
                                }
                            })
                                .then(response => {
                                    this.accountExists = response.data;
                                    if (this.accountExists == true) {
                                        this.btnDisabled = true;
                                    } else {
                                        this.btnDisabled = false;
                                    }
                                })
                                .finally(() => {
                                    this.loading = false;
                                });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        signup(e) {
            e.preventDefault();
            this.submitted = true;

            this.$refs.form.validate().then(success => {
                this.btnDisabled = true;
                this.loading = true;
                if (success) {
                    if (
                        this.user != null &&
                        this.user.groups != null &&
                        this.user.memberTypeAlias == 'school' &&
                        this.user.groups.length == 0
                    ) {
                        this.user.groups.push({
                            id: this.form.group,
                            name: this.form.group,
                            removed: false,
                            takeObjectInSelect: false
                        });

                        Axios.post('/clientdashboard/school/update', {
                            profile: this.user
                        }).catch(() => {
                            this.errorMessage =
                                'Er is iets mis gegaan met het updaten van uw gegevens. Excuses voor het ongemak';
                            this.error = true;
                            window.scrollTo(0, 0);
                            this.loading = false;
                        });
                    }

                    if (this.form.privacyAccepted == false) {
                        window.scrollTo(0, 0);
                        this.btnDisabled = false;
                        this.loading = false;
                        this.error = true;
                        this.errorMessage =
                            'Het accepteren van de algemene voorwaarden is verplicht';
                        return;
                    }

                    Axios({
                        method: 'post',
                        url: this.url,
                        data: this.form
                    })
                        .then(() => {
                            window.scrollTo(0, 0);
                            this.success = true;
                        })
                        .catch(() => {
                            this.errorMessage =
                                'Er is iets mis gegaan met het opslaan van de activiteit. Excuses voor het ongemak';
                            this.error = true;
                            window.scrollTo(0, 0);
                            this.loading = false;
                            this.btnDisabled = false;
                        });
                } else {
                    window.scrollTo(0, 0);
                    this.error = true;
                    this.btnDisabled = false;
                    this.loading = false;
                }
            });
        },
        getSignupTypes() {
            Axios.get('/api/inforequest/getsignuptypes').then(response => {
                this.signupTypes = response.data;
            });
        },
        getSuccessLink() {
            Axios.get('/api/inforequest/getsuccesslink').then(response => {
                this.successLink = response.data;
            });
        },
        getBookingLink() {
            Axios.get('/api/registration/getbookinglink').then(response => {
                this.bookingLink = response.data;
            });
        },
        getNoAccountMessage() {
            Axios.get('/api/registration/getnoaccountmessage').then(
                response => {
                    this.noAccountMessage = response.data;
                }
            );
        },
        getLoginText() {
            Axios.get('/api/registration/getlogintext').then(response => {
                this.loginText = response.data;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.message--login {
    border-bottom: 1px solid #cdcdcd;
    background-color: rgba(#fff, 0.85);
}
.v-application .v-picker__title.primary {
    background-color: $blue-7 !important;
}
.v-date-picker-table--date {
    .theme--light.v-btn.v-btn--disabled {
        color: #afafaf !important;
    }
}

.fa-chevron-right,
.fa-chevron-left {
    &:before,
    &:after {
        font-size: 0.825rem;
    }
}
.v-application .registration-form .primary--text {
    color: $blue-7 !important;
    caret-color: $blue-7 !important;
}

.input-error {
    color: $red;
}

.disabled {
    pointer-events: none;
}
.v-btn {
    &.v-date-picker-table__current {
        border-width: 2px;
    }
}
</style>
